/**
 * « Trousseau du site » (et de tout objet du registre du Trousseau) pour les fiches des métiers, exporté par le socle :
 * composant de l'outil Trousseau chargé à la demande (avec ses styles), squelette pendant le chargement.
 *   <TrousseauObjet ressource="sites" objetId={site.id} filiale={site.filiale} />
 * Détail : docs/TROUSSEAU.md › « Trousseau d'un objet ».
 */
import React from 'react';
import { ListSkeleton } from '../design';
import { useT } from './i18n';
import type { TrousseauObjetProps } from '../metiers/outils/trousseau/TrousseauObjet';

export type { TrousseauObjetProps };

const Composant = React.lazy(() => import('../metiers/outils/trousseau/TrousseauObjet'));

export function TrousseauObjet(props: TrousseauObjetProps) {
  const { t } = useT();
  return (
    <React.Suspense fallback={<ListSkeleton label={t('app.chargement')} rows={2} />}>
      <Composant {...props} />
    </React.Suspense>
  );
}
